import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, isRef as _isRef, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6add8b32"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-input-icon-left" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))

import { reactive, computed } from "vue";
import CategoryMultiSelect from "@/components/category/CategoryMultiSelect.vue";
import StockTable from "@/components/stock/StockTable.vue";
import {
  CONSTANTS,
  getImage,
  getPrices,
  getPurchasePrices,
  totalStock,
} from "@/graphql/utils/utils";
import { useProductsFilter } from "@/graphql/product/products";
import { Category, Product } from "@/graphql/types";
import { useStockPermissions } from "@/hooks/permissions/useStockPermission";


export default /*#__PURE__*/_defineComponent({
  __name: 'StockIndividual',
  props: {
    products: { default: () => [] },
    categories: { default: () => [] },
    loading: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;

const rowsPerPageOptions = CONSTANTS.rowsPerPageOptions;
const dialog = reactive({
  id: 0,
  show: false,
});
const { filters, clearFilter, priceMatchModeOptions } = useProductsFilter();
const { canUpdate } = useStockPermissions();
const storable = computed(() =>
  props.products.reduce((cum, prod) => {
    if (prod.type === 0) {
      cum.push({
        ...prod,
        quantity: totalStock(prod.stocks),
        sellingPrices: getPrices(prod),
        purchasePrices: getPurchasePrices(prod),
        createdAt: new Date(prod.createdAt),
      });
    }
    return cum;
  }, [])
);

function openStockDialog(id: number) {
  dialog.id = id;
  dialog.show = true;
}

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_Image = _resolveComponent("Image")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_Column = _resolveComponent("Column")!
  const _component_NumberFormatter = _resolveComponent("NumberFormatter")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DataTable, {
      value: storable.value,
      dataKey: "id",
      rows: 10,
      filters: _unref(filters),
      "onUpdate:filters": _cache[2] || (_cache[2] = ($event: any) => (_isRef(filters) ? (filters).value = $event : null)),
      responsiveLayout: "scroll",
      loading: _ctx.loading,
      class: "p-datatable-sm",
      globalFilterFields: ['name', 'reference'],
      showGridlines: "",
      "row-hover": false,
      filterDisplay: "menu",
      "rows-per-page-options": _unref(rowsPerPageOptions),
      paginator: "",
      "always-show-paginator": true
    }, {
      header: _withCtx(() => [
        _createVNode(_component_Toolbar, null, {
          start: _withCtx(() => [
            _createVNode(_component_Button, {
              type: "button",
              icon: "pi pi-filter-slash",
              label: _ctx.$t('clear'),
              class: "p-button-outlined p-mb-1",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(clearFilter)()))
            }, null, 8, ["label"])
          ]),
          end: _withCtx(() => [
            _createElementVNode("span", _hoisted_1, [
              _hoisted_2,
              _createVNode(_component_InputText, {
                modelValue: _unref(filters)['global'].value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(filters)['global'].value) = $event)),
                placeholder: _ctx.$t('search'),
                "icon-pos": "right"
              }, null, 8, ["modelValue", "placeholder"])
            ])
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          style: {"min-width":"3rem"},
          header: _ctx.$t('image')
        }, {
          body: _withCtx(({ data }) => [
            (data.image)
              ? (_openBlock(), _createBlock(_component_Image, {
                  key: 0,
                  src: _unref(getImage)(data.image),
                  height: 50,
                  preview: ""
                }, null, 8, ["src"]))
              : (_openBlock(), _createBlock(_component_Avatar, {
                  key: 1,
                  label: data.name[0],
                  size: "large"
                }, null, 8, ["label"]))
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          "show-add-button": false,
          showFilterOperator: false,
          header: _ctx.$t('product.reference'),
          filterField: "reference",
          field: "reference",
          style: {"max-width":"100px"},
          sortable: true,
          "sort-field": "reference"
        }, {
          filter: _withCtx(({ filterModel, filterCallback }) => [
            _createVNode(_component_InputText, {
              type: "text",
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
              class: "p-column-filter",
              onKeyup: _withKeys(filterCallback, ["enter"]),
              placeholder: _ctx.$t('product.filterByRef')
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeyup", "placeholder"])
          ]),
          filterclear: _withCtx(({ filterCallback }) => [
            _createVNode(_component_Button, {
              type: "button",
              icon: "pi pi-times",
              onClick: ($event: any) => (filterCallback()),
              class: "p-button-warning",
              label: _ctx.$t('prime.clear')
            }, null, 8, ["onClick", "label"])
          ]),
          filterapply: _withCtx(({ filterCallback }) => [
            _createVNode(_component_Button, {
              type: "button",
              icon: "pi pi-search",
              onClick: ($event: any) => (filterCallback()),
              class: "p-button-success p-ml-1",
              label: _ctx.$t('search'),
              "icon-pos": "right"
            }, null, 8, ["onClick", "label"])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          "show-add-button": false,
          showFilterOperator: false,
          header: _ctx.$t('product.name'),
          filterField: "name",
          field: "name",
          style: {"min-width":"12rem"},
          sortable: true,
          "sort-field": "name"
        }, {
          filter: _withCtx(({ filterModel, filterCallback }) => [
            _createVNode(_component_InputText, {
              type: "text",
              onKeyup: _withKeys(filterCallback, ["enter"]),
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
              class: "p-column-filter",
              placeholder: _ctx.$t('product.filterByName')
            }, null, 8, ["onKeyup", "modelValue", "onUpdate:modelValue", "placeholder"])
          ]),
          filterclear: _withCtx(({ filterCallback }) => [
            _createVNode(_component_Button, {
              type: "button",
              icon: "pi pi-times",
              onClick: ($event: any) => (filterCallback()),
              class: "p-button-warning",
              label: _ctx.$t('prime.clear')
            }, null, 8, ["onClick", "label"])
          ]),
          filterapply: _withCtx(({ filterCallback }) => [
            _createVNode(_component_Button, {
              type: "button",
              icon: "pi pi-search",
              onClick: ($event: any) => (filterCallback()),
              class: "p-button-success p-ml-1",
              label: _ctx.$t('search'),
              "icon-pos": "right"
            }, null, 8, ["onClick", "label"])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          showFilterMatchModes: false,
          "show-add-button": false,
          showFilterOperator: false,
          field: "category.label",
          sortable: true,
          "filter-field": "category.id",
          header: _ctx.$t('product.category')
        }, {
          filter: _withCtx(({ filterModel, filterCallback }) => [
            _createVNode(CategoryMultiSelect, {
              modelValue: filterModel.value,
              "onUpdate:modelValue": [($event: any) => ((filterModel.value) = $event), ($event: any) => (filterCallback())],
              items: _ctx.categories,
              style: {"max-width":"220px"}
            }, null, 8, ["modelValue", "onUpdate:modelValue", "items"])
          ]),
          filterclear: _withCtx(({ filterCallback }) => [
            _createVNode(_component_Button, {
              type: "button",
              onClick: ($event: any) => (filterCallback()),
              class: "p-button-warning p-button-sm",
              label: _ctx.$t('prime.clear'),
              icon: "pi pi-times"
            }, null, 8, ["onClick", "label"])
          ]),
          filterapply: _withCtx(({ filterCallback }) => [
            _createVNode(_component_Button, {
              label: _ctx.$t('search'),
              "icon-pos": "right",
              type: "button",
              icon: "pi pi-search",
              class: "p-button-sm p-ml-1",
              onClick: ($event: any) => (filterCallback())
            }, null, 8, ["label", "onClick"])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          "sort-field": "quantity",
          sortable: true,
          field: "quantity",
          header: _ctx.$t('stock.quantity'),
          "show-add-button": false,
          showFilterOperator: false,
          "filter-field": "quantity",
          dataType: "numeric"
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_NumberFormatter, {
              value: data.quantity
            }, null, 8, ["value"])
          ]),
          filter: _withCtx(({ filterModel }) => [
            _createVNode(_component_InputNumber, {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
              "max-fraction-digits": 20,
              min: 0,
              mode: "decimal"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          filterclear: _withCtx(({ filterCallback }) => [
            _createVNode(_component_Button, {
              type: "button",
              onClick: ($event: any) => (filterCallback()),
              class: "p-button-warning p-button-sm",
              label: _ctx.$t('prime.clear')
            }, null, 8, ["onClick", "label"])
          ]),
          filterapply: _withCtx(({ filterCallback }) => [
            _createVNode(_component_Button, {
              label: _ctx.$t('search'),
              type: "button",
              icon: "pi pi-search",
              class: "p-button-sm",
              onClick: ($event: any) => (filterCallback())
            }, null, 8, ["label", "onClick"])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          "show-add-button": false,
          showFilterOperator: false,
          field: "purchasePrices",
          header: _ctx.$t('product.purchasePrice'),
          filterField: "purchasePrices",
          filterMatchModeOptions: _unref(priceMatchModeOptions),
          sortable: true,
          "sort-field": "purchasePrices"
        }, {
          filter: _withCtx(({ filterModel, filterCallback }) => [
            _createVNode(_component_InputNumber, {
              type: "text",
              onKeyup: _withKeys(filterCallback, ["enter"]),
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
              modelModifiers: { number: true },
              class: "p-column-filter"
            }, null, 8, ["onKeyup", "modelValue", "onUpdate:modelValue"])
          ]),
          filterclear: _withCtx(({ filterCallback }) => [
            _createVNode(_component_Button, {
              type: "button",
              icon: "pi pi-times",
              onClick: ($event: any) => (filterCallback()),
              class: "p-button-warning",
              label: _ctx.$t('prime.clear')
            }, null, 8, ["onClick", "label"])
          ]),
          filterapply: _withCtx(({ filterCallback }) => [
            _createVNode(_component_Button, {
              type: "button",
              icon: "pi pi-search",
              onClick: ($event: any) => (filterCallback()),
              class: "p-button-success p-ml-1",
              label: _ctx.$t('search'),
              "icon-pos": "right"
            }, null, 8, ["onClick", "label"])
          ]),
          _: 1
        }, 8, ["header", "filterMatchModeOptions"]),
        _createVNode(_component_Column, {
          "show-add-button": false,
          showFilterOperator: false,
          header: _ctx.$t('product.sellingPrice'),
          filterField: "sellingPrices",
          field: "sellingPrices",
          filterMatchModeOptions: _unref(priceMatchModeOptions),
          sortable: true,
          "sort-field": "sellingPrices"
        }, {
          filter: _withCtx(({ filterModel, filterCallback }) => [
            _createVNode(_component_InputNumber, {
              type: "text",
              onKeyup: _withKeys(filterCallback, ["enter"]),
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
              modelModifiers: { number: true },
              class: "p-column-filter"
            }, null, 8, ["onKeyup", "modelValue", "onUpdate:modelValue"])
          ]),
          filterclear: _withCtx(({ filterCallback }) => [
            _createVNode(_component_Button, {
              type: "button",
              icon: "pi pi-times",
              onClick: ($event: any) => (filterCallback()),
              class: "p-button-warning",
              label: _ctx.$t('prime.clear')
            }, null, 8, ["onClick", "label"])
          ]),
          filterapply: _withCtx(({ filterCallback }) => [
            _createVNode(_component_Button, {
              type: "button",
              icon: "pi pi-search",
              onClick: ($event: any) => (filterCallback()),
              class: "p-button-success p-ml-1",
              label: _ctx.$t('search'),
              "icon-pos": "right"
            }, null, 8, ["onClick", "label"])
          ]),
          _: 1
        }, 8, ["header", "filterMatchModeOptions"]),
        _createVNode(_component_Column, {
          header: _ctx.$t('controls'),
          style: {"min-width":"8rem"}
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_Button, {
              onClick: ($event: any) => (openStockDialog(data.id)),
              icon: "pi pi-pencil",
              "icon-pos": "right",
              label: _ctx.$t('edit'),
              class: "p-button-text",
              disabled: !_unref(canUpdate)
            }, null, 8, ["onClick", "label", "disabled"])
          ]),
          _: 1
        }, 8, ["header"])
      ]),
      _: 1
    }, 8, ["value", "filters", "loading", "rows-per-page-options"]),
    (dialog.id)
      ? (_openBlock(), _createBlock(StockTable, {
          key: 0,
          modelValue: dialog.show,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dialog.show) = $event)),
          product: _ctx.products.find((p) => p.id === dialog.id)
        }, null, 8, ["modelValue", "product"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})